import { Stack } from '@mui/system';
import { Card, CardContent, CardMedia, Typography, useTheme } from '@mui/material';

import { SvgColor } from '../svg-color';

interface Props {
  title?: string;
  iconImg?: any;
  days?: number;
  LossOfPayLeaves?: boolean;
  totalAllowedLeaves?: number;
}

const LeaveStatusCard = ({ title, iconImg, days, LossOfPayLeaves, totalAllowedLeaves }: Props) => {
  const theme = useTheme();

  return (
    <Card
      sx={{
        borderRadius: '5px',
        width: '222px',
        border: LossOfPayLeaves ?? totalAllowedLeaves ? '2px solid' : 'none',
        borderColor: LossOfPayLeaves ? theme.palette.error.light : theme.palette.info.lighter,
      }}
    >
      {title && (
        <Stack
          sx={{
            borderRadius: '0px 0px 10px 10px',
            bgcolor: LossOfPayLeaves ? theme.palette.error.light : theme.palette.info.lighter,
            width: 'auto',
            mr: '25%',
            ml: '5%',
          }}
        >
          <Typography
            fontWeight={700}
            fontSize={13}
            sx={{
              padding: '5px',
              textAlign: 'center',
            }}
          >
            {title}
          </Typography>
        </Stack>
      )}
      <Stack direction={'row'} justifyContent={'space-evenly'} flexWrap={'wrap'}>
        <CardContent sx={{ fontSize: 15, fontWeight: 600 }}>{days} days</CardContent>
        {iconImg && (
          <CardMedia>
            <Stack
              sx={{
                width: 50,
                height: 50,
                mt: '10px',
                border: '2px dashed #D8DBDE',
                borderStyle: 'dashed',
                borderRadius: '50%',
              }}
            >
              <Stack
                sx={{
                  bgcolor: theme.palette.info.main,
                  width: 40,
                  height: 40,
                  borderRadius: '50%',
                  alignSelf: 'center',
                  mt: '3px',
                }}
              >
                <SvgColor
                  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                  src={`/assets/icons/card/${iconImg}.svg`}
                  sx={{
                    width: '40px',
                    height: '40px',
                    alignSelf: 'center',
                    color: theme.palette.common.white,
                    mt: '5px',
                  }}
                />
              </Stack>
            </Stack>
          </CardMedia>
        )}
      </Stack>
    </Card>
  );
};

export { LeaveStatusCard };
